<!--
 * @Description: 提交提现弹窗
 * @Author: gaohc
 * @Date: 2022-10-19 16:43:52
-->
<template>
  <div class="body">
    <el-dialog width="430px" title="提 现" :visible.sync="visible" :close-on-click-modal="false"
      :before-close="handleCancel" center>
      <div class="withdraw-content">
        <img class="withdraw-icon"  alt=""
          src="@/assets/finance/settlementAcctList/icon-settIement-withdraw.png">
        <div class="withdraw-text">提现申请已提交</div>
        <div class="withdraw-msg-item">
          <span>银行卡</span>
          <div>
            <span>{{ withdrawData.bankName }}</span>
            <span style="margin-left: 10px">{{ withdrawData.bankNo }}</span>
          </div>
        </div>
        <div class="withdraw-msg-item">
          <span>提现总额</span>
          <span>{{ withdrawData.withdrawAmount }}</span>
        </div>
      </div>
      <div class="dialog-footer">
        <el-button @click="handleCancel">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'SubmitWithdraw',

  props: ['visible', 'withdrawData'],
  
  methods:{
    handleCancel() {
      this.$emit("close-dialog")
    }
  } 
}
</script>

<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}
.withdraw-content {
  font-size: 14px;
  text-align: center;
}
.withdraw-icon {
  width: 118px;
  height: 83px;
  margin-bottom: 12px;
}
.withdraw-text {
  font-size: 16px;
  color: #000;
  margin-bottom: 30px;
}
.withdraw-msg-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #000;
  margin: 10px 25px 0 25px;
}
.dialog-footer {
  margin-top: 40px;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/finance/components/settlementacctlist/SubmitWithdraw.vue